module.exports = __webpack_public_path__ + "odstraneni-tetovaze_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_4_after_tn.jpg
// module id = 1427
// module chunks = 0